import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout'
import ContentHeader from '../layout/ContentHeader'
import httpClient from '../../../http/HttpRequest'
import { DELETE_PRODUCT, PRODUCT_LIST } from '../../../data/url'
import TableLayout from '../layout/TableLayout'
import { PRODUCT_STATUS } from '../../../data/constant'
import Alert from '../../../feature/Alert'
import FormLayout from '../layout/FormLayout'

export default function ProductList() {

    const [list, setProductData] = useState([]);

    const tableHeaders = ['#', 'product_name', 'price', 'stock', 'gst', 'status', 'edit', 'delete'];

    const keys = ["product_name", "price", "stock_quantity", "gst_rate", "status", "btnEdit", "btnDelete"];

    const btnData = {
        btnEdit: {
            name: "edit", link: "/root/product/update",modal:true,modalName:"product"
        },
        btnDelete: {
            name: "delete", method: deleteProduct
        }
    }

    useEffect(() => {
        productData();
    }, []);

    const deleteRecord = async (id) => {       
        const res = await httpClient.post(DELETE_PRODUCT, { category_id: id });
        if (res.requestStatus === "OK") {
            const result = res.result;
            if (result.status === 1) {
                productData();
                Alert.success(result.message);
            } else {
                Alert.error(result.message);
            }
        }
    }

    function deleteProduct(id) {
        deleteRecord(id);
    }

    const reloadData= () => {
        productData();
    }

    const productData = async (payload = {}) => {
        const res = await httpClient.post(PRODUCT_LIST, payload);
        if (res.requestStatus === "OK") {
            const result = res.result;
            if (result.status === 1) {
                setProductData(result.data);
            }
        }
    }

    const [formData, setFormData] = useState({
        formTitle: 'Search Customer',
        formFields: [          
            { label: 'product', id: 'product', type: 'text', name: 'product_name', value: '', className: "col-md-3", placeholder: 'Enter name' },
        ],
        formErrors: { product_name: ''},
    });

    const handleFieldChange = (fieldName, value) => {
        setFormData((prevFormData) => {
            const updatedFormFields = prevFormData.formFields.map((field) =>
                field.name === fieldName ? { ...field, value: value } : field
            );
            return {
                ...prevFormData,
                formFields: updatedFormFields,
            };
        });
    }

    const handleFieldBlur = () => { }

    const handleSubmit = (e) => {
        e.preventDefault();
        let post = {};
        const updatedFormFields = formData.formFields.map((field) => {
            post[field.name] = field.value;
            return field;
        });
        setFormData((prevFormData) => ({
            ...prevFormData,
            formFields: updatedFormFields,
        }));
        productData(post);
    }

    return (
        <AdminLayout>
            <div className="content-wrapper">
                <ContentHeader
                    title="products"
                    newButton="new"
                    newButtonLink="root/product/add"
                    modal={true}
                    modalName="product"
                    refreshData={reloadData}
                />
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <FormLayout
                                formTitle={formData.formTitle}
                                formFields={formData.formFields}
                                formErrors={formData.formErrors}
                                onFieldChange={handleFieldChange}
                                onFieldBlur={handleFieldBlur}
                                onSubmit={handleSubmit}
                                isModal
                                search
                            />
                            <TableLayout
                                headers={tableHeaders}
                                keys={keys}
                                tableData={list}
                                id="product_id"
                                btnData={btnData}
                                statusKey="status"
                                statusObject={PRODUCT_STATUS}
                                numberKey={["price", "stock_quantity","gst_rate"]}
                                refreshData={reloadData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </AdminLayout>
    )
}
